document.addEventListener('DOMContentLoaded', function () {

   const observer = new MutationObserver(() => {
      const cards = document.querySelectorAll('.splide__slide .trgg-google-review-card');

      if (cards.length === 0) return;

      observer.disconnect();

      cards.forEach((card) => {
         const stars = card.querySelector('.trgg-stars');
         const content = card.querySelector('.trgg-google-review-content');
         const image = card.querySelector('.trgg-review-carousel-google__grid');
         const user = card.querySelector('.trgg-display-flex.trgg-flex-gap-3');

         const leftWrapper = document.createElement('div');
         const rightWrapper = document.createElement('div');
         const mainWrapper = document.createElement('div');

         leftWrapper.className = 'review-left';
         rightWrapper.className = 'review-right';
         mainWrapper.className = 'review-main-wrapper';

         if (user && stars) {
            const userInfoColumn = user.querySelector('.trgg-display-flex.trgg-flex-column');
            if (userInfoColumn) {
               userInfoColumn.appendChild(stars);
            }
         }

         if (content) leftWrapper.appendChild(content);
         if (user) leftWrapper.appendChild(user);

         const iconImage = document.createElement('img');
         iconImage.className = "gicon_image";
         iconImage.src = "https://cdn.shopify.com/s/files/1/0721/0670/5074/files/google_icon_6ba39105-6a25-48c8-be5b-67f091a191e5.webp";
         if (user) user.appendChild(iconImage);

         if (image) rightWrapper.appendChild(image);

         card.innerHTML = '';
         mainWrapper.appendChild(leftWrapper);
         mainWrapper.appendChild(rightWrapper);
         card.appendChild(mainWrapper);

         const hasImage = rightWrapper.querySelector('img');
         if (!hasImage) {
            rightWrapper.style.display = 'none';
            leftWrapper.style.flex = '100%';
         }
      });
   });



   observer.observe(document.body, {
      childList: true,
      subtree: true,
   });

});





